import { loadView } from '@/router'

export default [
  {
    path: 'reconciliation',
    name: 'billing-reconciliation',
    component: loadView('Application/Billing/Reconciliation'),
    showInAlfred: true,
    alfredTitle: 'Billing - Reconciliation'
  }
]
